import React from 'react';

// The Contribution % header in two lengths. CSS shows the full label when the table is wide enough
// to give the column room for it, and the short one otherwise (see .contribution-rate-header in
// _configs.scss), so the header is never cut off with an ellipsis. Called as a plain function from
// list.ts, like the other contribution cells.
const ContributionRateHeader = () => (
  <>
    <span className="contribution-rate-label-full">Contribution %</span>
    <span className="contribution-rate-label-short">Contrib. %</span>
  </>
);

export default ContributionRateHeader;
